import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useChatsStore } from '@/stores/chats/chats.store';
import { useInstitutionsStore } from '@/stores/institutions';
import { useSocketStore } from '@/stores/socket';
import { ESocketSendMessageType } from '@/types/socket';

/**
 * Chat layout wrapper component.
 * Ensures that join/leave messages for chats are sent only once, avoiding duplicates
 * when navigating between pages like Waiting Room and Chat.
 * It also clears the selected chat on unmount.
 * @returns JSX.Element - A layout component that renders child routes via Outlet.
 */
export const ChatLayout = () => {
  const { isConnected, sendMessage } = useSocketStore((state) => ({
    isConnected: state.isConnected,
    sendMessage: state.sendMessage,
  }));
  const { selectedChatId, clearSelectedChat } = useChatsStore((state) => ({
    selectedChatId: state.selectedChat?.id,
    clearSelectedChat: state.clearSelectedChat,
  }));
  const currentInstitutionId = useInstitutionsStore(
    (state) => state.currentInstitution?.id,
  );

  useEffect(() => {
    if (!isConnected || !selectedChatId || !currentInstitutionId) return;

    sendMessage({
      type: ESocketSendMessageType.CHAT_START,
      body: {
        institutionId: currentInstitutionId,
        chatId: selectedChatId,
      },
    });

    return () => {
      sendMessage({
        type: ESocketSendMessageType.CHAT_STOP,
        body: {
          institutionId: currentInstitutionId,

          chatId: selectedChatId,
        },
      });
    };
  }, [currentInstitutionId, isConnected, selectedChatId, sendMessage]);

  useEffect(() => {
    return clearSelectedChat;
  }, [clearSelectedChat]);

  return <Outlet />;
};
